import { compose, hoistStatics, lifecycle, withHandlers, withState, defaultProps, withProps } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AddNew from './AddNew';
import WithLoading from '../../../../../components/WithLoading';
import fh from '../../../../../helpers/form.helper';
import FeedbackService from '../../../../../services/feedback.service';
import ModuleService from '../../../../../services/module.service';
import { settingsActions } from '../../../../../reducers/settings';

const sendRequest = props => async (e) => {
  e.preventDefault();
  const { formData, mulTempFiles, multId, history, setErrors } = props;
  let files = [];
  let canSubmit = true;
  if (mulTempFiles[multId] && mulTempFiles[multId].length) {
    files = mulTempFiles[multId].map((file) => {
      if (file.uploadingPc !== 100) canSubmit = false;
      return file.id;
    });
  }
  if (canSubmit) {
    const resp = await FeedbackService.update({ ...formData, files });
    if (resp.model) {
      history.goBack();
    } else {
      setErrors(resp.errors);
    }
  }
};

const mapStateToProps = state => ({
  mulTempFiles: state.upload.mulTempFiles,
  modulesSettings: state.modules.modulesSettings,
});

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  ...fh.defaultRecompose({}),
  withState('isLoading', 'setIsLoading', false),
  withState('item', 'setItem', null),
  withState('errors', 'setErrors', {}),
  lifecycle({
    async componentDidMount() {
      this.props.updateSettings({ hasLoadedPage: true });
    },
  }),
  withProps(props => ({
    backgroundColor: props.modulesSettings[ModuleService.TYPE_FEEDBACK].color ?
      props.modulesSettings[ModuleService.TYPE_FEEDBACK].color : props.modulesSettings[ModuleService.TYPE_FEEDBACK].default_color,
    backgroundCover: props.modulesSettings[ModuleService.TYPE_FEEDBACK].cover,
    enableCoverColor: props.modulesSettings[ModuleService.TYPE_FEEDBACK].enable_cover_color,
  })),
  defaultProps({
    multId: 'feedback-new',
  }),
  withHandlers({
    sendRequest,
    onChange: fh.onChangeFormDataElement,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(AddNew)));



// WEBPACK FOOTER //
// ./src/views/modules/feedback/feedbackItem/addNew/index.js